import Grid from "@mui/material/Grid";
import LinkStyled from "shared/ui/LinkStyled";
import RegisterSchoolTeachersForm from "../components/RegisterSchoolTeachersForm";
import AuthCardLayout from "../components/AuthCardLayout";

const RegisterSchoolTeachers = () => {

    return (
        <Grid container spacing={4} justifyContent="center">
            <AuthCardLayout image="/images/account-type-1.svg" title="Brio în școli" size="large" showBackButton={true}>
                <RegisterSchoolTeachersForm/>
                <LinkStyled to="/login/scoala">Autentificare</LinkStyled>
            </AuthCardLayout>
        </Grid>
    );
}

export default RegisterSchoolTeachers;